import { AbstractControl, ValidatorFn } from '@angular/forms';
import { AtsFileTypes } from '@ats/utility';
import { getFilesFromControl } from './files-from-control.function';

export function fileTypeValidator(acceptedTypes: AtsFileTypes[]): ValidatorFn {
	return (control: AbstractControl) => {
		const files = getFilesFromControl(control);

		if (!files) {
			return null;
		}

		const retVal = files
			.map(file => file.type)
			.every(fileType => acceptedTypes.some(acceptedType => fileType === acceptedType))
			? null
			: { fileType: true };

		return retVal;
	};
}
